import { api } from '@/shared/api/client';

import type { TriageStats } from './types';

export interface TriageStatsParams {
  /** ISO instants. Absent means the last seven days, which is what the back defaults to. */
  from?: string;
  to?: string;
}

export const statsKeys = {
  triage: (params: TriageStatsParams) => ['stats', 'triage', params] as const,
};

export const statsApi = {
  triage: (params: TriageStatsParams = {}): Promise<TriageStats> =>
    api.get<TriageStats>('/api/stats/triage', { ...params }),
};
